import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

import Header from "../components/Header";
// import Footer from "../components/Footer";
import FooterNew from "../components/Footer/FooterNew";
import "../../static/fonts/fonts.css";
import "./index.css";
import "../styles/_global.scss";
import "../styles/_functional.scss";

class TemplateWrapper extends React.Component {
  constructor({ props }) {
    super(props);
  }

  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getUrlParams(search) {
    let hashes = search.slice(search.indexOf("?") + 1).split("&");
    return hashes.reduce((params, hash) => {
      let [key, val] = hash.split("=");
      return Object.assign(params, { [key]: decodeURIComponent(val) });
    }, {});
  }

  componentDidMount() {
    const params = this.getUrlParams(this.props.location.search);

    Object.entries(params).forEach(param => {
      this.setCookie(param[0], param[1], 30); //  2 days to expire
    });
  }

  render() {
    const { children } = this.props;
    return (
      <div>
        <Helmet
          title="Global Citizen Year"
          meta={[
            { name: "description", content: "" },
            { name: "keywords", content: "" },
            {
              name: "google-site-verification",
              content: "h1s9I2U2chQB6x0ryIe-VoYMM8bTiUqfiKNx5fZ7MYA"
            }
          ]}
        >
          <link rel="shortcut icon" href="/favicon.png" type="image/png" />
          <link
            rel="canonical"
            href={`https://www.globalcitizenyear.org${
              this.props.location.pathname
            }`}
          />
          <script type="text/javascript">
          {
              `var _vwo_code=(function(){
                   var account_id=325225,
                   settings_tolerance=2000,
                   library_tolerance=2500,
                   use_existing_jquery=false,

                   f=false,d=document;
                   return{
                       use_existing_jquery:function(){
                           return use_existing_jquery;
                       },library_tolerance:function(){
                           return library_tolerance;
                       },finish:function(){
                           if(!f){f=true;var a=d.getElementById('_vis_opt_path_hides');if(a)a.parentNode.removeChild(a);}
                       },finished:function(){
                           return f;
                       },load:function(a){
                           var b=d.createElement('script');b.src=a;b.type='text/javascript';
                           b.innerText;
                           b.onerror=function(){
                               _vwo_code.finish();
                           };
                           d.getElementsByTagName('head')[0].appendChild(b);
                       },init:function(){
                           settings_timer=setTimeout('_vwo_code.finish()',settings_tolerance)
                           ;var a=d.createElement('style'),b='body{opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;}',h=d.getElementsByTagName('head')[0];a.setAttribute('id','_vis_opt_path_hides');
                           a.setAttribute('type','text/css');
                           if(a.styleSheet)a.styleSheet.cssText=b;
                           else a.appendChild(d.createTextNode(b));
                           h.appendChild(a);
                           this.load('//dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&r='+Math.random());
                           return settings_timer;
                       }
                   };
               }());_vwo_settings_timer=_vwo_code.init()`
          }
          </script>
        </Helmet>
        <Header
            location={this.props.location}
         />
        <div>{children()}</div>

        <FooterNew />
        <script
          dangerouslySetInnerHTML={{
            __html: `
                          (function(h,o,t,j,a,r){
                              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                              h._hjSettings={hjid:1055036,hjsv:6};
                              a=o.getElementsByTagName('head')[0];
                              r=o.createElement('script');r.async=1;
                              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                              a.appendChild(r);
                          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
                          `
          }}
        />
        <script
          dangerouslySetInnerHTML={{
            __html: `var _gaq = _gaq || [];
                              _gaq.push(['_setAccount', 'UA-7831396-1']);
                              _gaq.push(['_trackPageview']);
                              (function() {
                                var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
                                ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
                                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
                            })();`
          }}
          />
      </div>
    );
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js